import Gauge from '@/components/Gauge';

import { Text } from '@simplywallst/ui-core';

import { formatterPercentage } from '@/utilities/format';

import { Card } from '../Card';

export interface Props {
  portfolioValue: number | null;
  marketValue: number | null;
}

export const DividendGrowthRate = ({ portfolioValue, marketValue }: Props) => {
  return (
    <Card
      title="Dividend Growth Rate"
      description={
        <Text color="inherit" typography="xSmall">
          This chart presents a comparison between your portfolio's Dividend
          Growth Rate and the market average. The Dividend Growth Rate is a
          measure of the year-over-year increase in dividends paid by the
          portfolio's holdings. It's a key indicator of a company's financial
          health and its ability to consistently increase dividend payouts. A
          higher Dividend Growth Rate in your portfolio compared to the market
          suggests a robust and growing income stream, reflecting strong company
          performance and commitment to shareholder returns. Conversely, a lower
          rate may indicate more stable but slower-growing dividends. Use this
          comparison to understand your portfolio's dividend growth potential
          relative to broader market trends, aiding in strategic investment
          planning.{' '}
          <a
            href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-New-Portfolio-Analysis-Calculations"
            rel="noreferrer nofollow"
            target="_blank"
          >
            Learn more
          </a>
        </Text>
      }
    >
      <Gauge
        keys={['portfolio', 'market']}
        entities={{
          portfolio: portfolioValue,
          market: marketValue,
        }}
        numTicks={5}
        title="Dividend Growth"
        from={0}
        to={0.4}
        formatter={formatterPercentage}
      />
    </Card>
  );
};
